import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const RemoveWalletIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M12 20C16.38 20 20 16.37 20 12C20 7.62 16.37 4 11.99 4C7.62 4 4 7.62 4 12C4 16.37 7.63 20 12 20ZM12 18.67C8.3 18.67 5.34 15.7 5.34 12C5.34 8.3 8.29 5.33 11.99 5.33C15.69 5.33 18.66 8.3 18.67 12C18.67 15.7 15.7 18.67 12 18.67ZM8.92 12.67H15.07C15.51 12.67 15.81 12.43 15.81 12.02C15.81 11.59 15.53 11.35 15.07 11.35H8.92C8.46 11.35 8.17 11.59 8.17 12.02C8.17 12.43 8.48 12.67 8.92 12.67Z" />
		</svg>
	)
}

export default RemoveWalletIcon
